<script setup lang="ts" generic="T">
import { Link } from '@inertiajs/vue3';
import type { LengthAwarePaginator } from 'types';

defineProps<{
    response: LengthAwarePaginator<T>;
    only?: string[];
}>();

function label(value: string) {
    return value.replace(' Previous', '').replace('Next ', '');
}
</script>

<template>
    <div
        v-if="response.last_page > 1"
        class="mt-4"
        align="center">
        <div class="pagination pagination-rose-500">
            <template 
                v-for="(link, key) in response.links"
                :key="key">
                <div
                    v-if="link.url === null"
                    class="pagination-link"
                    :class="{
                        disabled: !link.url
                    }">
                    <span v-html="label(link.label)" />
                </div>
                <Link
                    v-else
                    :href="link.url"
                    :only="only"
                    class="pagination-link"
                    :class="{ 'active': link.active }"
                    preserve-scroll
                    preserve-state>
                    <span v-html="label(link.label)" />
                </Link>
            </template>
        </div>
    </div>
</template>